import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import KTitle from './KTitle';

const styles = {
  tile: {
    display: 'flex',
    flexGrow: 1,
    height: 500,
    backgroundColor: 'white',
    borderRadius: 8,
    width: '100%',
    overflow: 'auto',
  },
  tileContainer: {
    minWidth: 300,
    width: '100%',
    marginTop: 36,
    marginLeft: 24,
    marginRight: 24,
  },
  title: {
    margin: 0,
    marginTop: 12,
    marginBottom: 12,
    fontWeight: 600,
  },
};

const KTile = ({
  title,
  children,
  containerStyle,
  className,
  cy,
}) => (
  <div data-cy={cy} className={`ktile-width${className || ''}`} style={{ ...styles.tileContainer, ...containerStyle }}>
    <KTitle style={styles.title} title={<FormattedMessage id={title} />} />
    <div style={styles.tile}>
      {children}
    </div>
  </div>
);

KTile.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  containerStyle: PropTypes.object,
  className: PropTypes.string,
  cy: PropTypes.string,
};

export default KTile;



// WEBPACK FOOTER //
// ./src/components/KJRN/KTile.js